var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSetTicketLineCreator = function SvgSetTicketLineCreator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0L16.0073 9.81173e-06C20.1807 0.00752699 22.0204 3.25445 21.3734 7.09091C20.7269 10.924 18.3938 12.9916 16.0073 13L16 13L15.9927 13C13.6062 12.9916 11.273 10.924 10.6266 7.09091C9.97959 3.25445 11.8193 0.00752695 15.9927 9.8096e-06L16 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.5C14.9624 14.4963 13.9811 14.2206 13.0991 13.7151C9.8801 15.6741 5.07878 18.7847 4.65003 20.1545C4.31535 21.2238 4.15299 22.4766 4.07423 23.4404C4.00395 24.3005 4.69959 25 5.56254 25H26.4375C27.3005 25 27.9961 24.3005 27.9258 23.4404C27.8471 22.4766 27.6847 21.2238 27.35 20.1545C26.9213 18.7847 22.12 15.6741 18.901 13.7152C18.0189 14.2206 17.0377 14.4963 16 14.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 30.5C9 29.6716 8.32843 29 7.5 29H1.5C0.671573 29 0 29.6716 0 30.5C0 31.3284 0.671573 32 1.5 32H7.5C8.32843 32 9 31.3284 9 30.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 29C20.3284 29 21 29.6716 21 30.5C21 31.3284 20.3284 32 19.5 32H12.5C11.6716 32 11 31.3284 11 30.5C11 29.6716 11.6716 29 12.5 29H19.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 30.5C32 29.6716 31.3284 29 30.5 29H24.5C23.6716 29 23 29.6716 23 30.5C23 31.3284 23.6716 32 24.5 32H30.5C31.3284 32 32 31.3284 32 30.5Z",
    fill: "currentColor"
  })));
};
export default SvgSetTicketLineCreator;